import { z } from 'zod';

import { TransitAddressSchema } from './utils';

export const TransitNonArrivalDataSchema = z.object({
  CustomsOfficeOfDestinationActualReferenceNumber: z.string(),
  TC11DeliveryDate: z.union([z.date(), z.string()]).nullable().optional(),
  EnquiryText: z.string().optional().nullable(),
  ConsigneeActual: z
    .object({
      identificationNumber: z.string().optional().nullable(),
      name: z.string().optional().nullable(),
      Address: TransitAddressSchema.optional(),
    })
    .optional(),
});
export type TransitNonArrivalData = z.infer<typeof TransitNonArrivalDataSchema>;

export const TransitNonArrivalInfoSchema = z.object({
  transitId: z.string().min(1, { message: 'Required' }),
  data: TransitNonArrivalDataSchema,
});
export type TransitNonArrivalInfo = z.infer<typeof TransitNonArrivalInfoSchema>;
